/**
 * A mapping from language (e.g., "en") to CSE search engine ID.
 *
 * Update this when setting up the search engine config as part of
 * https://khanacademy.atlassian.net/wiki/spaces/CP/pages/1988100175/How+to+add+new+KA+locales+languages
 */
export default {
    ar: "004984196166817161901:gdpedlrlf9g",
    as: "304a0a1a847484d86",
    az: "004984196166817161901:5w0yncpabcg",
    bg: "004984196166817161901:kkyqb1ggjqw",
    bn: "004984196166817161901:kz6dzctvuua",
    cs: "004984196166817161901:rsjzpabv29m",
    da: "004984196166817161901:g5hgtepfxye",
    de: "004984196166817161901:vprchfdk1oq",
    el: "ecb493f698b77b55a",
    en: "004984196166817161901:gt3nscsxv5o",
    "en-pt": "004984196166817161901:4_wpoanobqi",
    es: "004984196166817161901:al7qrkuctie",
    fr: "004984196166817161901:byi6kb9tpb0",
    gu: "004984196166817161901:_tllxx9isau",
    he: "004984196166817161901:-ds3__p-dow",
    hi: "004984196166817161901:f7p0popxntk",
    hu: "004984196166817161901:uzs14outals",
    hy: "004984196166817161901:tvjil2s2eai",
    id: "004984196166817161901:h-jqv4innbg",
    is: "8017dc7479e6f7c81",
    it: "004984196166817161901:mct-ghoqkn0",
    ja: "004984196166817161901:821ugkeknfq",
    ka: "004984196166817161901:7migkubcut8",
    kk: "0fee75ccb39a34baa",
    km: "004984196166817161901:9koana4kz4s",
    kn: "004984196166817161901:cz41o_gbqvs",
    ko: "004984196166817161901:oumndhpf7l8",
    ky: "619990dfbbf1f6193",
    lt: "181ef4eee75e1050b",
    lv: "ab30469a789419e08",
    mn: "004984196166817161901:xr-fjss0suk",
    mr: "cd101deb77c36288d",
    my: "004984196166817161901:njy_d7ombdm",
    nb: "004984196166817161901:sfuyrfbkmce",
    nl: "004984196166817161901:7ggebi319fs",
    pa: "5f898b47468ab398f",
    pl: "004984196166817161901:zinxrddeuwu",
    pt: "004984196166817161901:15uvkfnrndm",
    "pt-pt": "004984196166817161901:rhvogmk2xlm",
    ro: "2ad1af34513e3c14f",
    ru: "004984196166817161901:sy1-qskjnii",
    "sgn-us": "e0a8e33bd2adc419c",
    sr: "004984196166817161901:kf_yitzvzuq",
    sv: "004984196166817161901:3ph5qlb03ki",
    ta: "004984196166817161901:7alqbewbjmc",
    te: "43a4b411a26a1478a",
    th: "fc4d4476538c5573e",
    tr: "004984196166817161901:wpo31s8bqom",
    uk: "8017cfb2e1f804366",
    uz: "004984196166817161901:ceqmo8eld20",
    vi: "63ed02e719b98fa54",
    "zh-hans": "004984196166817161901:mxd848w_0hk",
} as Record<string, string>;
